// ============================================================
// TN FOOD — Carte du restaurant (prix TTC, service compris)
// Mettre à jour les plats et prix ici.
// ============================================================

export const menuSections = [
  {
    id: "entrees",
    title: "Entrées",
    items: [
      { name: "Brik à l'œuf", description: "Feuille de malsouka croustillante, œuf, thon, câpres, persil", price: "7,50 €" },
      { name: "Salade méchouia", description: "Poivrons grillés, tomates, ail, huile d'olive", price: "7,00 €" },
      { name: "Salade tunisienne", description: "Tomates, concombre, oignon, poivron, olives, thon", price: "7,00 €" },
      { name: "Ojja", description: "Œufs, tomates, poivrons, merguez ou crevettes", price: "8,50 €" },
      { name: "Chorba frik", description: "Soupe traditionnelle au blé vert concassé, agneau ou poulet", price: "7,50 €" },
      { name: "Slata Tounsia", description: "Salade cuite à base de légumes et thon", price: "7,00 €" },
    ],
  },
  {
    id: "plats",
    title: "Plats principaux",
    items: [
      { name: "Couscous royal", description: "Semoule, agneau, poulet, merguez, légumes de saison", price: "18,50 €" },
      { name: "Couscous poulet", description: "Semoule, poulet, légumes", price: "15,50 €" },
      { name: "Couscous poisson", description: "Semoule, poisson frais, légumes", price: "17,50 €" },
      { name: "Tajine agneau", description: "Aux coings ou aux pruneaux", price: "18,00 €" },
      { name: "Tajine poulet", description: "Aux olives et citron confit", price: "16,00 €" },
      { name: "Kamounia", description: "Ragoût d'agneau ou de bœuf aux épices, cumin, harissa", price: "16,50 €" },
      { name: "Ojja royale", description: "Œufs, merguez, crevettes, poivrons", price: "15,00 €" },
      { name: "Lablabi", description: "Soupe de pois chiches, pain rassis, œuf, thon, harissa", price: "12,50 €" },
      { name: "Kafteji", description: "Légumes frits, œuf, thon, harissa", price: "13,00 €" },
      { name: "Merguez grillées", description: "Avec frites maison et salade", price: "14,00 €" },
      { name: "Brochettes de poulet marinées", description: "Avec frites maison et salade", price: "15,00 €" },
      { name: "Brochettes d'agneau", description: "Avec frites maison et salade", price: "17,00 €" },
      { name: "Assiette mixte grillades", description: "Brochettes, merguez, kefta, frites, salade", price: "19,50 €" },
    ],
  },
  {
    id: "formules",
    title: "Formules",
    items: [
      { name: "Formule midi entrée + plat", description: "Du mardi au vendredi, hors jours fériés", price: "16,50 €" },
      { name: "Formule midi entrée + plat + dessert", description: "Du mardi au vendredi, hors jours fériés", price: "19,50 €" },
      { name: "Formule enfant", description: "Plat + dessert + boisson", price: "10,00 €" },
    ],
  },
  {
    id: "desserts",
    title: "Desserts",
    items: [
      { name: "Baklawa", description: "Pâtisserie feuilletée au miel et aux amandes", price: "5,50 €" },
      { name: "Makroud", description: "Semoule fourrée aux dattes, miel", price: "5,50 €" },
      { name: "Samssa", description: "Feuilleté aux amandes et sésame", price: "5,50 €" },
      { name: "Kaak warka", description: "Anneaux aux amandes, eau de rose", price: "6,00 €" },
      { name: "Assiette de pâtisseries orientales", description: "Assortiment de 4 pièces", price: "7,50 €" },
      { name: "Salade de fruits frais de saison", description: "Fruits frais selon arrivage", price: "5,50 €" },
    ],
  },
  {
    id: "boissons",
    title: "Boissons",
    items: [
      { name: "Thé à la menthe", description: "Thé vert, menthe fraîche, pignons", price: "3,50 €" },
      { name: "Café turc", description: "", price: "2,50 €" },
      { name: "Café expresso", description: "", price: "2,00 €" },
      { name: "Jus de fruits frais", description: "Orange, citron, grenade selon saison", price: "4,00 €" },
      { name: "Sodas et eaux", description: "", price: "2,50 € à 3,50 €" },
      { name: "Boissons alcoolisées", description: "Vin, bière", price: "4,50 € à 22,00 € (la bouteille)" },
    ],
  },
];

export const signatureDishes = [
  {
    name: "Couscous royal",
    description: "Semoule fine, agneau, poulet, merguez et légumes de saison.",
    price: "18,50 €",
    // TODO: remplacer par une vraie photo du couscous TN FOOD (avec l'accord du client)
    image: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Tajine agneau",
    description: "Agneau fondant aux coings ou aux pruneaux, mijoté aux épices.",
    price: "18,00 €",
    // TODO: remplacer par une vraie photo du tajine TN FOOD
    image: "https://images.unsplash.com/photo-1682370207954-c8a9cccaabb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Pâtisseries orientales",
    description: "Baklawa, makroud, samssa et kaak warka faits maison.",
    price: "5,50 €",
    // TODO: remplacer par une vraie photo des pâtisseries TN FOOD
    image: "https://images.unsplash.com/photo-1761828122856-8703baac8e86?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Thé à la menthe",
    description: "Thé vert, menthe fraîche et pignons, servi à la tunisienne.",
    price: "3,50 €",
    // TODO: remplacer par une vraie photo du thé TN FOOD
    image: "https://images.unsplash.com/photo-1591299089616-c9604047b1a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const menuNotes = {
  allergens:
    "Liste des allergènes disponible sur demande. Conformément au règlement UE n° 1169/2011, notre personnel est à votre disposition pour vous communiquer la composition détaillée de nos plats.",
  tva: "Prix TTC, service compris. TVA : 10 % restauration sur place, 5,5 % ou 10 % vente à emporter, 20 % boissons alcoolisées.",
};
